export default __webpack_public_path__ + "static/media/AcceleronsGallery_31.d584fc12.JPG";